<template>
    <div class="page-container">
      <slot />
    </div>
  </template>
  
  <script>
  export default {
  name:"PageContainer"
  }
  </script>
  
  <style scoped>
  .page-container{
      padding: 40px 15px 20px 15px ;
      height: 100%;
      /* height: calc(100vh - 76px); */
      width: 100%;
      background: #FAFAFA 0% 0% no-repeat padding-box;
  }

  @media screen and (max-width: 1279px) {
    .page-container{
      height: calc(100vh - 56px);
  
  }
}

  @media screen and (max-width: 767px) {
    .page-container{
      height: 100%;
      padding: 15px 30px 15px 30px ;
  }

  }
  </style>